import type { AcademyState } from './types';

export const demoState: AcademyState = {
  academyName: 'Harbour Jiu-Jitsu Academy',
  coachName: 'Coach Maya',
  students: [
    { id: 'student-1', name: 'Alex Morgan', belt: 'Blue', stripes: 2, attendance90: 27, streakWeeks: 4, progressions: [{ id: 'progress-1', belt: 'Blue', stripes: 2, awardedOn: '2026-08-12', note: 'Consistent technical growth.' }] },
    { id: 'student-2', name: 'Sam Nkosi', belt: 'White', stripes: 3, attendance90: 29, streakWeeks: 3, progressions: [] },
    { id: 'student-3', name: 'Jordan Lee', belt: 'Purple', stripes: 1, attendance90: 21, streakWeeks: 4, progressions: [{ id: 'progress-3', belt: 'Purple', stripes: 1, awardedOn: '2026-06-21' }] },
    { id: 'student-4', name: 'Casey Jacobs', belt: 'White', stripes: 1, attendance90: 16, streakWeeks: 2, progressions: [] },
  ],
  sessions: [
    {
      id: 'session-1',
      title: 'Evening Gi — Fundamentals',
      startsAt: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
      attendance: {},
    },
  ],
  posts: [
    {
      id: 'post-1',
      author: 'Coach Maya',
      body: 'Excellent focus on guard retention tonight. Small details, consistent rounds.',
      createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    },
  ],
};
